export default "__VITE_ASSET__B2QEI7GO__"